import type { TabProps } from '@talos/kyoko';
import { OMSView } from './OMSView';

export const orderFormViews = [
  OMSView.SalesOrder,
  OMSView.SalesRFQForm,
  OMSView.RFQForm,
  OMSView.NewOrderForm,
] as const;
export const newOrderTab: TabProps = { id: OMSView.NewOrderForm, label: 'New Order' };
export const rfqTab: TabProps = { id: OMSView.RFQForm, label: 'New RFQ' };
export const salesOrderTab: TabProps = { id: OMSView.SalesOrder, label: 'Sales Order' };
export const salesRfqTab: TabProps = { id: OMSView.SalesRFQForm, label: 'Sales RFQ' };
export const manualRfqPricingTab: TabProps = { id: OMSView.ManualRFQPricingForm, label: 'Manual Pricing' };
export const careOrderTab: TabProps = { id: OMSView.CareOrderForm, label: 'Care Order' };

export function isOrderFormView(view: OMSView) {
  return orderFormViews.includes(view as (typeof orderFormViews)[number]);
}

export const OMS_POPOUT_GROUP_VIEWS = {
  OrderForms: {
    name: 'OrderForms',
    views: [OMSView.NewOrderForm, OMSView.RFQForm, OMSView.SalesOrder, OMSView.SalesRFQForm],
  },
  Cards: {
    name: 'Cards',
    views: [OMSView.Cards],
  },
  ManualRFQPricingForm: {
    name: 'ManualRFQPricingForm',
    views: [OMSView.ManualRFQPricingForm],
  },
  CareOrderForm: {
    name: 'CareOrderForm',
    views: [OMSView.CareOrderForm],
  },
  ManualDealTradeForm: {
    name: 'ManualDealTradeForm',
    views: [OMSView.ManualDealTradeForm],
  },
  AppInbox: {
    name: 'AppInbox',
    views: [OMSView.NotificationsInbox],
  },
} as const;
